import {NOTIFICATION_CHECK_SUPPORT, NOTIFICATION_DISMISS_TYPE} from './notification.action';

import {INITIAL_STATE} from './notification.state';

export const NotificationReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case NOTIFICATION_CHECK_SUPPORT:
      return {
        ...state,
        visible: payload
      };
    case NOTIFICATION_DISMISS_TYPE:
      return {
        ...state,
        visible: false
      };
    default:
      return state;
  }
};
